import { mpfRListsHttp } from '../../api/mpf-r-lists-http'
import { isArchivedFilter } from '../data'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface DueOutDiscussions {
  Comment: string
  CommentDocumentName: string
  CommentType: string
  DueOutGUID: string
  DueOutID: number
  IsActionComment: boolean
  ItemCreated: string
  ItemCreatedBy: string
  ItemModified: string
  ItemModifiedBy: string
  Subject: string
  Title: string
  eKey: string
  eTag: string
}

interface DueOutDiscussionsArgs {
  DueOutGUID: string
  // isArchivedFilter: false | null | true
  // isAscending?: boolean
  // orderBy?: string
  refresh: boolean
}

const COLUMN_NAMES = {
  Comment: 'Comment',
  CommentDocumentName: 'CommentDocumentName',
  CommentType: 'CommentType',
  DueOutGUID: 'DueOutGUID',
  DueOutID: 'DueOutID',
  EKey: 'eKey',
  ETag: 'eTag',
  ID: 'ID',
  IsActionComment: 'IsActionComment',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemCreatedByFirstName: 'ItemCreatedBy/firstName',
  ItemCreatedByLastName: 'ItemCreatedBy/lastName',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  ParentCommentCode: 'ParentCommentCode',
  Subject: 'Subject',
}
const LIST_NAME = 'DueOutDiscussionsList'

const getDueOutDiscussions = async (
  args: DueOutDiscussionsArgs
): Promise<DueOutDiscussions[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const filter = `DueOutGUID eq '${args?.DueOutGUID}'`

  const items = await list
  .query()
  .select(COLUMN_NAMES.Comment,
    COLUMN_NAMES.Subject,
    COLUMN_NAMES.ItemCreatedByFirstName, 
    COLUMN_NAMES.ItemCreatedByLastName,
    COLUMN_NAMES.ItemCreated,
    COLUMN_NAMES.CommentType,
    COLUMN_NAMES.EKey,
    COLUMN_NAMES.CommentDocumentName,
    COLUMN_NAMES.ParentCommentCode)
  .expand(COLUMN_NAMES.ItemCreatedBy)
  .orderBy([{ ascending: false, orderBy: COLUMN_NAMES.ItemCreated }])
  .filter(filter)
  .get()

  return [...items] as DueOutDiscussions[]
}
export {
  COLUMN_NAMES,
  type DueOutDiscussions,
  type DueOutDiscussionsArgs,
  LIST_NAME,
  getDueOutDiscussions,
}
